















































































import {Vue, Component} from 'vue-property-decorator';
import {namespace} from 'vuex-class';
import {Admin} from '@/types';
import RadioElement from '@/components/common/RadioElement.vue';
import ValidateInput from '@/components/common/input/ValidateInput.vue';
import DateCalendar from '@/components/common/datepicker/DateCalendar.vue';
import {addClass, removeClass} from '@/utils/classUtils';
import {popupResize} from '@/utils/ncp';
import {getToday} from '@/utils/dateUtils';
import {GetMallsConfigurationsRequest, PostAccumulationsRequest, PutAccumulationsSubtractRequest ,ManageReasonType} from 'supporter';
import {AxiosResponse} from 'axios';
const adminModule = namespace('admin');

@Component({
  metaInfo() {
    return (this as any).viewTitle;
  },
  components: {RadioElement, ValidateInput, DateCalendar}
})
export default class Accumulate extends Vue {
  private get viewTitle() {
    let title = this.accName + ' ' + this.$t('MEMBER_POPUP_ACCUMULATE_A_D');
    return {
      title
    };
  }

  @adminModule.Getter('admin') private admin!: Admin;

  private accumulationName = '';
  private accumulationUnit = '';
  private get accName(): string {
    let accName = '';
    if (this.accumulationName !== undefined && this.accumulationName !== null && this.accumulationName !== '') {
      accName = this.accumulationName;
    } else {
      accName = this.$t('ACCUMULATION_DEFAULT_NAME') as string;
    }
    return accName;
  }

  // 지급 대상자
  private memberNames: string[] = [];
  private memberNumbers: number[] = [];
  // 지급/차감
  private reason: ManageReasonType = 'ADD_MANUAL';
  private reasonOption = {
    name: 'reasonType',
    data: [
      {
        id: 'reasonType_ADD_MANUAL',
        value: 'ADD_MANUAL',
        dispaly: 'MEMBER_POPUP_ACCUMLATE_PAYMENTS'
      },
      {
        id: 'reasonType_SUB_MANUAL',
        value: 'SUB_MANUAL',
        dispaly: 'MEMBER_POPUP_ACCUMLATE_DEDUCTION'
      }
    ]
  };
  private get reasonStr() {
    return this.reason === 'ADD_MANUAL' ? this.$t('MEMBER_POPUP_ACCUMLATE_PAYMENTS') : this.$t('MEMBER_POPUP_ACCUMLATE_DEDUC');
  }

  // 금액
  private amount = '';
  private amountErrFlg = '';
  private amountOptions = {
    name: 'amount',
    type: 'text-num'
  };

  // 지급 사유
  private detailReason = '';
  private detailReasonMaxLength = 200;

  // 유효기간 지정
  private validPeriod = 'default';
  private periodYmd: string = '';
  private calendarOption = {
    dateType: 'Ymd',
    name: 'accumulate',
    fromRanges: getToday(),
    placeholder: 'MEMBER_POPUP_PERIODYMD_PLACEHOLDER'
  };
  private async apply() {
    if (this.amount === '') {
      alert(this.$t('MEMBER_POPUP_ALERT_AMOUNT_NULL', [this.accName]));
      (this.$refs.amount as any).focus();
      return;
    }
    if (this.amount === '0') {
      alert(this.$t('MEMBER_POPUP_ALERT_AMOUNT_ZERO', [this.reasonStr]));
      (this.$refs.amount as any).focus();
      return;
    }
    if (this.detailReason === '') {
      alert(this.$t('MEMBER_POPUP_ALERT_REASON_DETAIL_NULL'));
      (this.$refs.detailReason as any).focus();
      return;
    }
    if (this.validPeriod === 'custom' && this.periodYmd === '') {
      alert(this.$t('MEMBER_POPUP_ALERT_PERIOD_YMD_NULL'));
      return;
    }
    const request: PutAccumulationsSubtractRequest = {
      data: {
        reason: this.reason,
        amount: Number(this.amount),
        registerAdminNo: this.admin.no,
        mallNo: Number(this.$route.query.mallNo),
        detailReason: this.detailReason,
        memberNo: this.memberNumbers[0],
      }
    }
    if (this.reason === 'ADD_MANUAL') {
        const postAccumulationsRequest: PostAccumulationsRequest = JSON.parse(JSON.stringify(request));
        postAccumulationsRequest.data.started = getToday() + ' 00:00:00';
        postAccumulationsRequest.data.expired = (this.validPeriod === 'default' ? null : this.periodYmd + ' 00:00:00');
        Promise.
        allSettled(
          this.memberNumbers.
          map(memberNo => ({data: {...postAccumulationsRequest.data, memberNo}})).
          map(this.$api.postAccumulations)
        ).
        then(statuses => this.courseInspection(statuses));
        return;
      } 
        Promise.
          allSettled(
            this.memberNumbers.
            map(memberNo => ({data: {...request.data, memberNo}})).
            map(this.$api.putAccumulationsSubtract)
        ).
        then(statuses => this.courseInspection(statuses));
  }
  private courseInspection(statuses: PromiseSettledResult<AxiosResponse<void>>[]){
      const [resolveCount, rejectCount] = statuses.reduce(
          ([resolve,reject],{status})=>status === 'rejected' ? [resolve, reject + 1] : [resolve + 1, reject]
            , [0,0])

            rejectCount 
              ? alert(`${rejectCount}건 실패 memberNo를 확인해주세요`) 
              : alert(this.$t('MEMBER_POPUP_ACCUMULATE_SUCCESS_MSG', {count: resolveCount, accumulateName: this.accName, accumulateStatus: this.reasonStr}));
          this.confirmCallback();
  }

  private confirmCallback() {
    if (this.$route.query && this.$route.query.callback) {
      $(window.opener.location).attr('href', `javascript:window.${this.$route.query.callback}();`);
    }
    this.cancel();
  }

  private cancel() {
    window.close();
  }

  private async mounted() {
    addClass(document.body, 'popup_small');
    if (this.$route.query) {
      // 지급 대상자
      const parseMemberNos = this.$route.query.memberNumbers as string;
      this.memberNumbers = parseMemberNos.split(',').map(Number);
      this.fetchMemberName();

      const request: GetMallsConfigurationsRequest = {
        pathParams: {
          mallNo: this.$route.query.mallNo as string
        },
        params: {
          key: 'MALL_ACCUMULATION'
        }
      };
      const {data} = await this.$api.getMallsConfigurations(request);
      if (data.completeSaved) {
        this.accumulationName = data.accumulationName;
        this.accumulationUnit = data.accumulationUnit;
      }
    }

    this.$nextTick(() => {
      popupResize();
    });
  }
    private async fetchMemberName() {
      this.memberNumbers.map(async (memberNo) => {
        const {data} = await this.$api.getMembersMemberNo({
           pathParams: {
             memberNo: memberNo.toString(),
            }
        })
        this.memberNames = data.memberId 
          ? [...this.memberNames, `${data.memberName}(${data.memberId})`] 
          : [...this.memberNames, `${data.memberName}(${window.$t('MEMBER_CRM_PAYCO_VIP')})`]
      })
    }

  private beforeDestroy() {
    removeClass(document.body, 'popup_small');
  }
}
